import { Component, OnInit, ViewChild } from '@angular/core';
import { RebateRequestComponent } from 'src/app/front-user/services/long-haul/rebate-request/rebate-request.component';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AknowledgeReceiveRequest, CommenterType } from 'src/app/shared/models/long-haul.model';
import { User } from 'src/app/front-user/shared/models/user.model';
import { Subject } from 'rxjs';
import { ErrorsEnum } from 'src/app/shared/models/enums.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-rebate-request-confirm-receiving-request',
  templateUrl: './rebate-request-confirm-receiving-request.component.html'
})

export class RebateRequestConfirmReceivingRequestComponent implements OnInit {
  //#region Properties & Variables
  private rebateRequestId: string = "";
  @ViewChild('rebateRequest',{static: false}) rebateRequest: RebateRequestComponent;
  private acknowledgeReceivingRequestResponseObject: ResponseObject = new ResponseObject();
  public isRequestSucceeded: boolean = false;
  //User Properties
  public currentUser: User = new User();
  //Submit Properties
  private aknowledgeReceiveRequest: AknowledgeReceiveRequest =  new AknowledgeReceiveRequest();
  //Get Aknowledge Receive Request
  private getAcknowledgeReceivingRequestResponseObject: ResponseObject = new ResponseObject();
  private isRequestReceived: boolean = false;
  public submitConfirmationMode: ConfirmationMode = ConfirmationMode.Success;
  //#endregion

  //#region  Constructor
  constructor(private longHaulService: LongHaulService, private globalServices: GlobalServices, private authenticationService: AuthenticationService) {
    //this.currentUser = this.globalServices.user;
    this.currentUser = this.authenticationService.currentUserValue;
  }
  //#endregion

  //#region Events & Methods
  ngOnInit() {
    //Enable Loader
    this.globalServices.isLoaderEnabled = true;
  }
  acknowledge(): void {
    if(this.rebateRequestId && this.rebateRequestId != ""){
      //Enable Loader
      this.globalServices.isLoaderEnabled = true;
      this.aknowledgeReceiveRequest.LongHaulRequestId = this.rebateRequestId;
      this.aknowledgeReceiveRequest.CommenterType = CommenterType.EconomicCommittee;
      this.aknowledgeReceiveRequest.EconomicCommitteeAdminEmail = this.currentUser.UserName != "" ? this.currentUser.UserName : this.currentUser.Email;
      //this.aknowledgeReceiveRequest.EconomicCommitteeAdminEmail = "alaa.emam@linkdev.com";
      this.acknowledgeReceivingRequest();
    }
  }
  acknowledgeReceivingRequest(): void {
    this.longHaulService.aknowledgeReceiveRequest(this.aknowledgeReceiveRequest).subscribe(
      data => this.acknowledgeReceivingRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.acknowledgeReceivingRequestCompleted()
    );
  }
  acknowledgeReceivingRequestCompleted(): void {
    if(!this.acknowledgeReceivingRequestResponseObject.Success){
      //Enable Error / Warning
      if(this.acknowledgeReceivingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.InternalServerError.toString())
        this.submitConfirmationMode = ConfirmationMode.Error;
      else if(this.acknowledgeReceivingRequestResponseObject.ErrorMessages[0] == ErrorsEnum.TaskCompletedByAnotherUser.toString())
        this.submitConfirmationMode = ConfirmationMode.Warning;
    }
    //Enable Confirmation
    this.isRequestSucceeded = true;
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  onRebateRequestLoadedFlag(flag: boolean) {
    if(flag){
      this.rebateRequestId = this.rebateRequest.rebateRequestLoaded.Id;
      this.rebateRequest.showOptionDev = false;
      this.rebateRequest.editModeAdmin = true;
      this.getAcknowledgeReceivingRequest();
    }
  }
  getAcknowledgeReceivingRequest(): void {
    this.longHaulService.getAknowledgeReceiveRequest(this.rebateRequestId).subscribe(
      data => this.getAcknowledgeReceivingRequestResponseObject = data,
      () => console.log("Something went wrong!!"),
      () => this.getAcknowledgeReceivingRequestCompleted()
    );
  }
  getAcknowledgeReceivingRequestCompleted(): void {
    if(this.getAcknowledgeReceivingRequestResponseObject.Success){
      this.isRequestReceived = this.getAcknowledgeReceivingRequestResponseObject.Data as boolean;
    } else {
      this.submitConfirmationMode = ConfirmationMode.Error;
      //Enable Confirmation
      this.isRequestSucceeded = true;
    }
    //Disable Loader
    this.globalServices.isLoaderEnabled = false;
  }
  //#endregion
}

enum ConfirmationMode {
  Success  = 1,
  Warning = 2,
  Error = 3
}
